import classNames from 'classnames';
import {Button} from 'components/Button';
import {getGridColumnStyles, Grid} from 'components/Grid';
import {Typography} from 'components/Typography';
import {HOME_ROUTE} from 'routing/constants';

import style from './style.module.scss';

const helperColumnStyle = getGridColumnStyles({md: 1});
const imageColumnStyle = getGridColumnStyles({md: 3});
const contentColumnStyle = getGridColumnStyles({md: 7});

export const Error404 = () => {
    return (
        <div className={style.root}>
            <Grid noRowGap>
                <div className={classNames(style.helper, helperColumnStyle)}></div>
                <picture className={classNames(style.picture, imageColumnStyle)}>
                    <img alt="Error 404" className={style.image} src="/images/404.svg" />
                </picture>
                <div className={classNames(style.content, contentColumnStyle)}>
                    <Typography className={style.title} color="black100" variant="h3">
                        Кажется, что то пошло не так
                    </Typography>
                    <Typography color="gray80" variant="p">
                        Страница, на которую вы пытаетесь попасть устарела, была удалена или был введен неверный адрес в
                        адресной строке.
                    </Typography>
                    <Button className={style.button} href={HOME_ROUTE}>
                        Вернуться на главную
                    </Button>
                </div>
            </Grid>
        </div>
    );
};
